import { render } from "./commission-rule.vue?vue&type=template&id=684cedf8"
import script from "./commission-rule.vue?vue&type=script&lang=js"
export * from "./commission-rule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__